export const caseStatus = Object.freeze({
  NEW: 'new',
  PENDING: 'pending',
  ASSIGNED: 'assigned',
  UNASSIGNED: 'unassigned',
  ARCHIVED: 'archived'
});

export const notificationStatus = Object.freeze({
  NEW: 'new',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected'
});

export const caseFlow = Object.freeze({
  LAWYER_CREATED: 'lawyerCreated',
  CLIENT_CREATED: 'clientCreated'
});

export default {
  states: [
    'Alabama (AL)',
    'Alaska (AK)',
    'Arizona (AZ)',
    'Arkansas (AR)',
    'California (CA)',
    'Colorado (CO)',
    'Connecticut (CT)',
    'Delaware (DE)',
    'District Of Columbia (DC)',
    'Florida (FL)',
    'Georgia (GA)',
    'Hawaii (HI)',
    'Idaho (ID)',
    'Illinois (IL)',
    'Indiana (IN)',
    'Iowa (IA)',
    'Kansas (KS)',
    'Kentucky (KY)',
    'Louisiana (LA)',
    'Maine (ME)',
    'Maryland (MD)',
    'Massachusetts (MA)',
    'Michigan (MI)',
    'Minnesota (MN)',
    'Mississippi (MS)',
    'Missouri (MO)',
    'Montana (MT)',
    'Nebraska (NE)',
    'Nevada (NV)',
    'New Hampshire (NH)',
    'New Jersey (NJ)',
    'New Mexico (NM)',
    'New York (NY)',
    'North Carolina (NC)',
    'North Dakota (ND)',
    'Ohio (OH)',
    'Oklahoma (OK)',
    'Oregon (OR)',
    'Pennsylvania (PA)',
    'Rhode Island (RI)',
    'South Carolina (SC)',
    'South Dakota (SD)',
    'Tennessee (TN)',
    'Texas (TX)',
    'Utah (UT)',
    'Vermont (VT)',
    'Virginia (VA)',
    'Washington (WA)',
    'West Virginia (WV)',
    'Wisconsin (WI)',
    'Wyoming (WY)',
  ],

  serviceTypes: [
    'Document Preparation', 
    'Document Review', 
    'Opinion', 
    'Representation', 
    'Consultation'
  ],

  userTypes: ['lawyer', 'client'],

  fieldsOfPractice: ['Intellectual Property', 'Criminal', 'Family', 'Commercial', 'Landlord/Tenant', 'Wills & Trusts', 'Personal Injury'],

  solicitationWarningThread: 'Initiating chat with a lawyer may be considered a solicitation of professional services which could ultimately become billable.',

  solicitationWarningCase: {
    lawyer: 'You are about to invite a lawyer to a case. This may be considered a solicitation of professional services which could ultimately become billable.',
    collaborator: 'You are about to invite a collaborator to a case. The collaborator will have full access to this case and all related threads.',
    client: 'You are about to invite a client to a case. The client will have full access to this case and all related threads',
  },

  solicitationWarningCaseByEmail: {
    lawyer: 'You are about to invite a lawyer to a case via email. This may be considered a solicitation of professional services which could ultimately become billable.',
    collaborator: 'You are about to invite a collaborator or collaborators to a case via email. The collaborator(s) will have full access to this case and all related threads.',
    client: 'You are about to invite a client or clients to a case via email. The client(s) will have full access to this case and all related threads',
  },  

  caseStatus,

  caseFlow
};
